module.exports = __webpack_public_path__ + "media/public/images/social/twitter-2a56ae5e2fd4e932629c439c5244717d.svg";